import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import {
  ISyllabusByIdResponse,
  SyllabusResponse,
  SyllabusState,
} from '../../interface/syllabus.interface';
import {
  fetchSyllabus,
  addSyllabus,
  updateSyllabus,
  fetchSyllabusById,
} from '../action/syllabus.action';

const initialState: SyllabusState = {
  syllabus: [],
  syllabusById: null,
  isLoading: false,
  isLoadingById: false,
  error: null,
  total: 0,
};

const syllabusSlice = createSlice({
  name: 'syllabus',
  initialState,
  reducers: {
    resetSyllabus: (state) => {
      state.syllabusById = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSyllabus.pending, (state) => {
        state.syllabus = [];
        state.total = 0;
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSyllabus.fulfilled, (state, action: PayloadAction<SyllabusResponse>) => {
        state.isLoading = false;
        state.syllabus = action.payload.data.Syllabus;
        state.total = action.payload.data.total;
        state.error = null;
      })
      .addCase(fetchSyllabus.rejected, (state, action) => {
        state.syllabus = [];
        state.total = 0;
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_fetch_syllabus', 'Failed to fetch syllabus');
      });

    builder
      .addCase(fetchSyllabusById.pending, (state) => {
        state.isLoadingById = true;
        state.error = null;
        state.syllabusById = null;
      })
      .addCase(
        fetchSyllabusById.fulfilled,
        (state, action: PayloadAction<ISyllabusByIdResponse>) => {
          state.isLoadingById = false;
          state.syllabusById = action.payload.data.Syllabus;
          state.error = null;
        },
      )
      .addCase(fetchSyllabusById.rejected, (state, action) => {
        state.isLoadingById = false;
        state.syllabusById = null;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_fetch_syllabus', 'Failed to fetch syllabus');
      });

    builder
      .addCase(addSyllabus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addSyllabus.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(addSyllabus.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_create_syllabus', 'Failed to create syllabus');
      });

    builder
      .addCase(updateSyllabus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateSyllabus.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateSyllabus.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_update_syllabus', 'Failed to update syllabus');
      });
  },
});

export const { resetSyllabus } = syllabusSlice.actions;

export default syllabusSlice.reducer;
